<template>
  <div class="row">
    <div v-bind:class="{'overlay' : loading.save}">
      <div v-bind:class="{'loader': loading.save }"></div>
    </div>
    <div class="col-md-7" >
      <card>
        <h5 slot="header" class="title">Finante Proiect</h5>
        <label>Valoare contract dirigentie (lei)</label>
        <div class="row">
          <div class="col-md-3">
            <base-input type="number"
                        placeholder="lei"
                        v-model="project.contract_val">
            </base-input>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-4">
            <h6>Incasari</h6>
          </div>
        </div>
        <div v-for="(payment, index) in project.payments" class="row">
          <base-input class="ml-3" type="number"
                      v-model="payment.payment_amount"
                      :disabled="payment.project_id"
                      placeholder="lei"
          >
          </base-input>
          <base-input class="ml-3" type="date"
                      v-model="payment.payment_date"
                      :disabled="payment.project_id">
          </base-input>
          <base-button @click="deletePayment(index)" type="danger" size="sm" icon style="margin-left: 10px">
            <i class="tim-icons icon-simple-remove"></i>
          </base-button>
        </div>
        <base-button class="ml-3" @click="addPayment" type="success" size="sm">Adauga
        </base-button>
        <base-button type="default" class="pull-right" size="sm" @click="$router.push('/projects-list')">Inapoi</base-button>
        <base-button :loading="loading.save" class="ml-3 pull-right" @click="save" type="primary" size="sm" :disabled="!project.contract_val">Salveaza
        </base-button>
      </card>
    </div>
    <div class="col-md-5">
      <card>
        <h5 slot="header" class="title">Date Proiect</h5>
        <div class="row">
          <div class="col-md-12">
            <label>Client: <p class="text-primary">{{project.customer.nume}}</p></label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label>Denumire proiect: <p class="text-primary">{{project.lucrari}}</p></label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label>Adresa proiect: <p class="text-primary">Str. {{project.lucrare_str}} nr. {{project.lucrare_nr_str}}, {{project.lucrare_oras}}</p></label>
          </div>
        </div>
        <br>
        <label>Total incasat</label>
        <div class="progress" style="height: 15px;">
          <div class="progress-bar" role="progressbar" v-bind:style="{ width: totalCashed + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{totalCashed}}%</div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
  const { required, minLength } = require('vuelidate/lib/validators');
  import axios from "axios";
  import CustomersSelect from "../../components/Inputs/CustomersSelect";

  export default {
    name: "ProjectForm",
    components: {CustomersSelect},
    data() {
      return {
        project: {
          contract_val: 0,
          customer: {},
          payments: [],
        },
        loading: {
          save: false
        },
      }
    },
    computed: {
      totalCashed: function () {
        let total = 0;
        for (const payment of this.project.payments) {
          total += Number(+payment.payment_amount);
        }
        let totalCashed = total/Number(this.project.contract_val)*100
        return totalCashed.toFixed(2);
      }
    },
    methods: {
      getData() {
        if (this.$route.params.projectId) {
          axios.post("project/payments/details", {projectId: this.$route.params.projectId})
                  .then((res) => {
                    this.project = res.data;
                  })
                  .catch((err) => {
                    console.log(err);
                  });
        }
      },
      save() {
        this.loading.save = true;
        axios.post('project/payments/save', this.project)
                .then((res) => {
                  this.loading.save = false;
                  this.notifySuccess();
                  this.getData();
                })
                .catch((err) => {
                  this.loading.save = false;
                  console.log(err);
                });
      },
      addPayment() {
        this.project.payments.push({payment_amount: 0, payment_date: new Date(Date.now()).toISOString().split('T')[0]})
      },
      deletePayment(paymentIndex) {
        this.$dialog.confirm('Esti sigur ca vrei sa stergi plata?', {
          okText: 'Da',
          cancelText: 'Nu'
        })
                .then(() => {
                  this.project.payments.splice(paymentIndex, 1);
                })
                .catch(() => {
                });
      },
      notifySuccess() {
        this.$notify({
          type: 'success',
          message: 'Modificarile au fost salvate cu succes',
          icon: 'tim-icons icon-bell-55',
        })
      },
    },
    mounted() {
      this.getData();
    }
  }
</script>

<style scoped>

</style>
